import type { CommonModalProps } from '@frontend/web-react';
import { Modal, Text, Title, YStack } from '@frontend/web-react';
import { StripeProvider, StripeUnavailable } from '@frontend/web/components';
import { CardModalSpinner, CreditCardModalBody } from './components';

export type CreditCardFormProps = CommonModalProps & {
  declinedCard: boolean;
  focusedCardId: MaybeUndefined<string>;
};

export const CreditCardModal = ({ declinedCard, focusedCardId, isOpen, onClose }: CreditCardFormProps) => {
  const isEditing = !!focusedCardId;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={declinedCard ? 'Update card' : isEditing ? 'Edit default card' : 'Add new card'}
      titlesAlignment="start"
    >
      {isOpen ? (
        <StripeProvider
          loadingFallback={<CardModalSpinner />}
          reloadFallback={<StripeUnavailable onAction={() => window.location.reload()} variant="reload" />}
          retryFallback={(onRetry) => <StripeUnavailable onAction={onRetry} variant="retry" />}
        >
          <YStack gapY="md">
            {declinedCard ? (
              <YStack gapY="xs">
                <Title type="h5">Your last payment failed</Title>
                <Text color="secondary" type="p-sm">
                  Update your credit card info to continue using Duckbill.
                </Text>
              </YStack>
            ) : null}
            <CreditCardModalBody focusedCardId={focusedCardId} onClose={onClose} />
          </YStack>
        </StripeProvider>
      ) : null}
    </Modal>
  );
};
